module.exports = __webpack_public_path__ + "img/img2.da0d4724.png";